export const environment = {
    production: true,
    apiUrl: 'https://api.sitly.com/v2',
    name: 'prod',
};
